'use strict';

module.exports = require('./Radio');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.0.0@rc-radio/lib/index.js
 ** module id = 435
 ** module chunks = 0 1
 **/